import { Avatar, createStyles, makeStyles, Theme, withStyles } from '@material-ui/core';
import { NotificationAthlete } from 'oas';
import { jerseyOrLabel } from 'shared';
import clsx from 'clsx';

interface AthleteAvatarProps {
    athlete: NotificationAthlete;
    size?: 'small';
}
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        small: {
            width: theme.spacing(3.5),
            height: theme.spacing(3.5),
            fontSize: '1rem',
        },
        condensed: {
            fontSize: '0.75rem',
        },
    }),
);

const styles = () =>
    createStyles({
        colorDefault: {
            backgroundColor: 'var(--r-catapult-black)',
        },
    });

export const AthleteAvatar = withStyles(styles)((props: AthleteAvatarProps) => {
    const { athlete, size, ...rest } = props;
    const customClasses = useStyles();
    const athleteName = `${athlete?.first_name} ${athlete?.last_name}`;
    const athleteInitials = `${athlete?.first_name?.[0] ?? ''}${athlete?.last_name?.[0] ?? ''}`;
    const avatarLabel = jerseyOrLabel(athlete?.jersey, athleteInitials);

    return (
        <Avatar
            alt={athleteName}
            src={athlete.image_url}
            className={clsx(size ? customClasses[size] : undefined, avatarLabel.length > 2 && customClasses.condensed)}
            {...rest}
        >
            {avatarLabel}
        </Avatar>
    );
});
